<template>
    <div class="open">
        <div class="bg">
            <div class="btn">
            <img src="../../../assets/images/active/login.png" alt="" class="btn_image">
            <p class="font">挑选上架商品</p>
            <div class="mocen" @click="choiceGoods"></div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export default {
    data(){
        return{}
    },
    created(){
     document.getElementsByTagName("title")[0].innerText = "我是谜520表白商店";
    },
    methods:{
        choiceGoods(){
            this.$router.push("/goods");
        },
        getBuyList() {
          axios.post(this.$interfaces.getUserActivityLoveShop, {
          userGuid: this.$store.userguid,
          token: this.$store.token,
          ownerUserGuid: this.$store.state.userguid
        })
        .then(res => {
        //   console.log(res);
          this.goodsList = res.data.data.goodsList;
          if( this.goodsList.length <= 0){
            this.$router.push({ path: "/home" });
          }
          
        })
        .catch(err => {
          console.log(err);
        });
    },
    }
}
</script>
<style>
.open{
    width:100%;
    height: 100%;
}
.open .bg{
    background:url("../../../assets/images/active/bg/bgstart.png") left top no-repeat;
    background-size: cover;
    position: relative;
    height: 33.35rem;
    display: flex;
    justify-content: center;
}
.open .bg .btn{
    position: absolute;
    bottom:1.65rem;
    width:16rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    color:white;
    font-size: 1rem;
}
.open .bg .btn .mocen{
    position: absolute;
    left:0;
    top:0;
    width:16rem;
    height: 3rem;
}
.open .bg .btn .font{
    position: absolute;
    top:0;
    left:0;
    width:16rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    color:white;
    font-size: 1rem;
}
.open .bg .btn img{
    width:100%;
    height: 100%;
}
</style>





// WEBPACK FOOTER //
// src/components/active/view/start.vue